import { LICENSES_MAP_ERRORS } from '../constants';

const validateLicenses = ({
  stateName,
  professionValue,
  licenseNumber = '',
}) => {
  try {
    if (!stateName || !professionValue) {
      return {
        hasError: true,
        errorDetail: 'Select a valid state and profession',
      };
    }
    const LICENSE_MAP =
      LICENSES_MAP_ERRORS[stateName.trim()][professionValue.trim()];
    if (!RegExp(LICENSE_MAP.regex, 'i').test(licenseNumber.trim())) {
      return {
        hasError: true,
        errorDetail: LICENSE_MAP.error,
        errorArray: LICENSE_MAP.errorArray,
      };
    }
    return { hasError: false };
  } catch (error) {
    console.log('Bad state or profession values', error);
    return { hasError: true, errorDetail: 'Bad state or profession values' };
  }
};

export function validation(values, licenseNumberRequired) {
  let errors = {};

  if (!values.first_name) {
    errors.first_name = 'Required';
  }

  if (!values.last_name) {
    errors.last_name = 'Required';
  }

  if (!values.email) {
    errors.email = 'An email is required';
  }

  if (!values.password) {
    errors.password = 'A password is required';
  }
  if (values.password.length < 6) {
    errors.password = 'Password must be 6 characters';
  }

  if (licenseNumberRequired) {
    const validationResult = validateLicenses({
      stateName: values.state.value,
      professionValue: values.profession.value,
      licenseNumber: values.license_number,
    });
    if (validationResult.hasError) {
      errors.license_number = validationResult.errorDetail;
      errors.license_number_arr = validationResult.errorArray;
    }

    if (values.second_number) {
      const secondLicenseValidationResult = validateLicenses({
        stateName: values.second_state.value,
        professionValue: values.second_profession.value,
        licenseNumber: values.second_number,
      });
      if (secondLicenseValidationResult.hasError) {
        errors.second_number = secondLicenseValidationResult.errorDetail;
        errors.second_number_arr = secondLicenseValidationResult.errorArray;
      }
    }
  }
  return errors;
}

// transform the errors object to an array of errors:
// errors: { first_name: 'Required', license_number = 'Begin with OTA and no space (Ex: OTA123456)' }
// errors: ['Required', 'Begin with OTA and no space (Ex: OTA123456)']
export function validationArray(values, licenseNumberRequired) {
  const errors = validation(values, licenseNumberRequired) || {};
  let arr = [];
  for (const key in Object.key(errors)) {
    arr.push(errors[key]);
  }
  return arr;
}



// WEBPACK FOOTER //
// ./src/fixture/validation.js